import { ChevronLeft, ChevronRight } from 'lucide-react'; 

const PaginationButtons = ({ totalRecord, recordPerPage, currentPage, setCurrentPage,setNextPage,setPrevPage }) => {
    
    const totalPages = Math.ceil(totalRecord / recordPerPage);
    
    if (totalPages <= 1) return null; 
    
    const pages = [];
    for(let i = 1; i <= totalPages; i++){
        pages.push(i);
    }
    

    
    return (
        <div className="w-full p-3 flex justify-end items-center space-x-2 bg-gray-50 border-t border-gray-200">
            
            {/* Prev Button */}
            <button
                onClick={setPrevPage} 
                disabled={currentPage === 1}
                className="flex items-center py-1.5 px-3 rounded-lg text-sm font-medium text-gray-700 bg-white border border-gray-300 hover:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed transition"
            >
                <ChevronLeft size={16} />
                <span className="ml-1 hidden sm:inline">Prev</span>
            </button>
            
            {/* Page Number Buttons */}
            {pages.map((page) => (
                <button 
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className={`
                        px-3 py-1.5 text-sm font-semibold rounded-lg transition-colors 
                        ${currentPage === page
                            ? 'bg-blue-600 text-white shadow-md'
                            : 'bg-white text-gray-700 border border-gray-200 hover:bg-blue-50'
                        }`}
                >
                    {page}
                </button>
            ))}
            
            {/* Next Button */}
            <button
                onClick={setNextPage}
                disabled={currentPage === totalPages}
                className="flex items-center py-1.5 px-3 rounded-lg text-sm font-medium text-gray-700 bg-white border border-gray-300 hover:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed transition"
            >
                <span className="mr-1 hidden sm:inline">Next</span>
                <ChevronRight size={16} />
            </button>
            
             <div className='absolute left-10 text-xs text-gray-500 hidden sm:block'>
                Page {currentPage} of {totalPages}
            </div>
        </div>
    );
}

export default PaginationButtons;